<template>
  <div
    :class="`featured-story featured-story--theme-${mappedValue.theme}`"
  >
    <cdr-img
      v-if="mappedValue.showImage"
      :src="mappedValue.src"
      :alt="mappedValue.alt"
      loading="lazy"
      class="featured-story__decorative-image"
    />
    <h2
      v-if="mappedValue.heading"
      class="featured-story__heading"
      v-html="mappedValue.heading"
    />
    <p
      v-if="mappedValue.body"
      class="featured-story__body"
      v-html="mappedValue.body"
    />
    <div
      v-if="mappedValue.actions"
      class="featured-story__btn-wrapper"
    >
      <cdr-button
        v-for="({ target, text, style }, index) in mappedValue.actions"
        :key="`action-${index}`"
        :data-analytics-id="`${mappedValue.heading}_${text}`"
        :href="target"
        :modifier="`${style || 'secondary'}`"
        class="featured-story__btn"
        tag="a"
      >
        {{ text }}
      </cdr-button>
    </div>
  </div>
</template>

<script>
import { CdrButton, CdrImg } from '@rei/cedar';

export default {
  name: 'FeaturedStory',
  components: {
    CdrImg,
    CdrButton,
  },
  props: {
    resource: {
      type: Object,
      required: true,
    },
  },
  computed: {
    mappedValue() {
      const model = this.resource;
      return {
        theme: model.theme || '',
        actions: model.actions || {},
        heading: model.heading || '',
        body: model.description || '',
        showImage: !!(model.image?.src),
        src: model.image?.src || '',
        alt: model.image?.alt || '',
      };
    },
  },
};
</script>

<style lang="scss">

.featured-story {
  @include cdr-container;
  padding-top: $cdr-space-one-and-a-half-x;

  &--theme-sale {
    .featured-story__heading {
      color: $cdr-color-text-sale;
    }
  }

  &__decorative-image {
    &--top {
      width: 100%;
      vertical-align: top;
    }
    &--bottom {
      width: 100%;
      vertical-align: bottom;
    }
  }

  &__heading {
    @include cdr-text-heading-display-800;
    text-align: center;
    margin-bottom: $cdr-space-one-x !important;
    margin: 0 auto;
    @include cdr-sm-mq-up {
      @include cdr-text-heading-display-1000;
    }
    @include cdr-sm-mq-only {
      max-width: 700px;
    }
  }

  &__body {
    @include cdr-text-body-400;
    text-align: center;
    max-width: 524px;
    margin: 0 auto;
    padding-bottom: $cdr-space-three-quarter-x;
  }
  &__decorative-image{
    margin-bottom: $cdr-space-one-x;
    width: 100%;
    border-radius: 8px;
  }
  &__btn-wrapper {
    text-align: center;

    @include cdr-sm-mq-up {
      margin-bottom: $cdr-space-two-x;
    }
    .featured-story__btn {
      margin-left: $cdr-space-half-x;
      margin-right: $cdr-space-half-x;
      margin-bottom: $cdr-space-one-x;
    }
  }
}
</style>
